<template>
  <div id="app">
    <app-header></app-header>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/AppHeader.vue'
import AppFooter from '@/AppFooter.vue'
export default {
  mounted () {
  },
  components: {
    AppHeader, 
    AppFooter
  },
  data() {
    return {

    }
  },

  methods: {

  }

}
</script>

<style>
@import url('https://use.typekit.net/wln7vbi.css');

html { -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; font: 62.5%/1 sans-serif; }
body { margin:0; -moz-osx-font-smoothing: grayscale; -webkit-font-smoothing: antialiased; }
h1, h2, h3, h4, p, ol, ul { margin:0; padding:0; }
h1, h2, h3, h4 { font-size: inherit; font-weight: normal; }
a, button { color: inherit; }
a { text-decoration: none; }
img { vertical-align: top; max-width:100%; }
input, select, textarea, button { font: inherit; }
table { border-collapse: collapse; }

body { font: 1.8em "paralucent", sans-serif; position: relative; line-height: 1; }

.grey-box { background: #F8F8F8; color: #062573; }
.blue-box { background: #062165; color: white; }
.blue-box--light { background: #062573; color: white; }
.information-box { background: #BCC8E4; color: #062573; position: relative; padding: 50px; }
.information-box::before { content: "!"; width: 60px; height: 60px; background: #062573; color: white; position: absolute; border-radius: 50%; font-size: 4rem; display: flex; align-items: center; justify-content: center; top: -30px; left: -25px; }
.white-box { color: #062573; }

.wrapper { width: 92%; max-width: 1250px; margin: auto; }
.wrapper--spaced { padding: 80px 0; }
.wrapper--spaced-bottom { padding-bottom: 80px; }
.wrapper--centered { text-align: center; }

.grecaptcha-badge { display: none; }

#video_player { display: none; position: fixed; z-index:9999; margin: auto; left: 0;right: 0; top: 0; bottom: 0; justify-content: center; align-items: center; }
#video_player::before { content: " "; z-index:-1; position: fixed; top:0; bottom:0; left:0; right:0; background: rgba(0,0,0,0.7); }
#video_player.video_player--open { display: flex; }

.button { background: transparent; appearance: none; outline:0; border:0; text-decoration: none; text-transform: uppercase; font-weight: bold; padding: 7px 15px; font-size: 1.8rem; cursor: pointer; }
.button--white { background: white; color: #062573; }
.button--white:hover { background: #AAB7DA; }
.button--blue { background: #AAB7DA; color: white; }
.button--blue:hover { background:white; color: #062573; }
.button--red { background: #E0231C; color: white; }    
.button--red:hover { background: #A31E19; }
.button--fixed { min-width: 150px; }
.button--large { padding: 14px 18px; }

.title { color: #062573; font-size: 3.5rem; text-transform: uppercase; font-weight: bold; line-height: 1; }
.title--white { color: white; }
.title--red { color: #E0231C; }
.title--small { font-size: 2.5rem; }
.title--large { font-size: 4rem; }
.title--spaced { margin-bottom: 40px; }

.text { padding-bottom: 20px; line-height: 1.5; font-size: 1.9rem; font-weight: normal; }
.text:last-child { padding-bottom: 0; }
.text--bold { font-weight: bold; }
.text--center { text-align: center; }

.link { color: rgb(192, 0, 0); font-weight: bold; line-height: 1; }
.link:hover { text-decoration: underline; }

.cover { width: 100%; height: 700px; display: flex; background-repeat: no-repeat; background-size: cover; background-position: center 50%; }
.cover--small { height: 325px; display: flex; align-items: flex-end; justify-content: center; }
.cover--right { justify-content: flex-end; }
.cover--top { background-position: center 10%; }
.cover__content { display: flex; flex-direction: column; justify-content: center; }
.cover--right .cover__content { width: 50%; }
.cover__title { margin-bottom: 50px; font-size: 5rem; color: white; font-weight: bold; text-transform: uppercase; }
.cover--home .cover__title { margin-bottom: 10px; }
.cover--small .cover__title { text-shadow: 2px 2px 8px #000000a3; }
.cover__subtitle { margin-bottom: 10px; font-size: 3rem; font-weight: 500; color: white;  }

.jumbotron { background-size: contain; background-position: center; background-repeat: no-repeat; }

.social { display: flex; margin: -20px 0 0 -20px; }
.social__item { width: 50px; padding: 20px 0 0 20px; text-decoration: none; color: #333; display: flex; align-items: center; font-weight: bold; justify-content: center; }
.social__item > * { width: 100%; }

.wide-image { width: 100%; height: 400px; object-fit: cover; margin: 40px 0; }

.form { background: #F3F1F1; padding: 50px; display: flex; flex-wrap: wrap; }
.form--column { flex-direction: column; }
.form--boxless { background: inherit; padding:0; }
.form__item { width: 100%; display: flex; flex-direction: column; align-items: flex-start; margin-top: 20px; }
.form__item--duo { width: calc((100% - 20px) / 2); }
.form__item--duo + .form__item--duo { margin-left: 20px; }
.form__item label:not(.segment__label):not(.option) { color: #9C9C9C; font-weight: 400; font-size: 1.5rem; margin-bottom: 5px; }
.form__item > input, .form__item > select, .form__item > textarea { width: 100%; box-sizing: border-box; padding: 7px 5px; }
.form__item > input, .form__item > textarea { border: 1px solid rgb(0, 0, 0, 0.20); border-radius: 2px; outline: none; }
.form__item--large > input, .form__item--large > select, .form__item--large > textarea { font-size: 2rem; padding: 14px 18px; border: 0; border-radius: 3px; box-sizing: border-box; }
.form__input--short { width: 160px; }

.share-buttons { margin: 15px 0 10px 0; border-bottom: 1px solid #cccccc; padding-bottom: 20px; display: flex; justify-content: center; }
.share-buttons > * { margin: 0 5px; }

.thumbnail { position: relative; overflow: hidden; width: 100%; padding-top: 55%; }
.thumbnail__image { position: absolute; width: 100%; top:0; }
.thumbnail__control { position: absolute; bottom: 0; padding: 10px 30px 10px 40px; display: flex; align-items: center; background: rgba(0,0,0,0.6); color: white; font-weight: 300; }
.thumbnail__control::before { content: " "; left: 15px; width: 0; height: 0; position: absolute; border-left: 13px solid #fff; border-top: 8px solid transparent; border-bottom: 8px solid transparent; }

.grid { width: 100%; display: flex; flex-wrap: wrap; color: white; }
.grid__tile { flex:1; padding: 40px 90px; box-sizing: border-box; text-align: center; position: relative; overflow: hidden; }
.grid__tile--large-padding { padding: 70px 90px; }
.grid__tile--center { display: flex; flex-direction: column; justify-content: center; align-items: center; }
.grid__tile--black { background: rgba(0, 0, 0, 0.7); }
.grid__tile--red { background: rgba(171, 0, 0, 0.7); }
.grid__image { position: absolute; width: 100%; min-height: 100%; top: -9999px; bottom: -9999px; left: -9999px; right: -9999px; margin: auto; z-index: -1; }
.grid__title { font-weight: bold; font-size: 2.25rem; }
.grid__text { padding: 20px 0; }

  @media (max-width: 1100px) {

  }

  @media (max-width: 768px) {
    .cover { height: auto; min-height: 300px; padding: 40px 7.5%; padding-bottom: 20px; box-sizing: border-box; background-position: center; }
    .cover--right .cover__content { width: 100%; }
    .cover--home { background-image: url('./assets/cover-home-mobile.jpg')!important; background-position-y: top; padding-top: 330px; text-align: center; }
    .form:not(.form--boxless) { padding: 40px 15px; }
    .form__item { width: 100%; flex-direction: column; }
    .form__item > input, .form__item > select, .form__item > textarea { width: 100%; box-sizing: border-box; border: 1px solid #cccccc; border-radius: 2px; padding: 7px 5px; outline: none; margin:0; }
    .form__item--duo + .form__item--duo { margin-left: 0; }
  }

  
</style>
